module.exports = __webpack_public_path__ + "img/icon-cg.27022ac7.png";